// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
/**
 * Message d'erreur affiché : celui de l'API, jamais un message maison qui
 * masque la cause. `detail` prend trois formes selon la route, et le corps
 * d'erreur arrive parfois en chaîne non désérialisée selon l'appel.
 *
 * L'écran de facturation a le sien (`utils/formatFacturation`), qui lit aussi
 * les mentions manquantes et les motifs de ses refus.
 */
export function errorMessage(e, fallback) {
  let detail = e?.response?.data?.detail;
  if (detail === undefined && typeof e?.response?.data === 'string') {
    try { detail = JSON.parse(e.response.data)?.detail; } catch { /* corps non JSON */ }
  }
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail)) {
    // 422 de FastAPI : [{loc, msg}]. Le nom du champ fautif vaut mieux que le
    // seul « Value error », c'est le plus souvent une adresse mal formée.
    const rows = detail.map((d) => {
      const champ = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : null;
      return champ ? `${champ} : ${d?.msg}` : d?.msg;
    }).filter(Boolean);
    if (rows.length) return rows.join(' ; ');
  }
  if (detail && typeof detail === 'object') {
    const errors = Array.isArray(detail.errors) ? detail.errors.slice(0, 5).join(' ; ') : '';
    const assemble = [detail.message, errors].filter(Boolean).join(' : ');
    if (assemble) return assemble;
  }
  if (e?.response?.status) return `${fallback} (HTTP ${e.response.status})`;
  return e?.message || fallback;
}
